import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useMediaQuery,
  useTheme,
  Typography,
  Box
} from "@mui/material";
import { FaFileExcel } from "react-icons/fa";
import * as XLSX from "xlsx";
import { useState } from "react";

const ExportButton = ({ gridRef, fileName = "export.xlsx", exportColumns = [],disabled }) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [exportCount, setExportCount] = useState(0);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleExport = () => {
    const api = gridRef?.current;
    if (!api) return;

    const selectedRows = api.getSelectedRows();
    if (selectedRows.length === 0) {
      alert("Please select rows to export.");
      return;
    }

    setExportCount(selectedRows.length); // Save count for modal

    const filteredRows = selectedRows.map((row) => {
      const filtered = {};
      exportColumns.forEach((key) => {
        filtered[key] = row[key];
      });
      return filtered;
    });

    const worksheet = XLSX.utils.json_to_sheet(filteredRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

    XLSX.writeFile(workbook, fileName);

    const handleFocus = () => {
      setOpenDialog(true);
      window.removeEventListener("focus", handleFocus);
    };
    window.addEventListener("focus", handleFocus);
  };

  const handleClearSelection = () => {
    gridRef?.current?.deselectAll();
    setOpenDialog(false);
  };

  return (
    <>
    <div >
      <Button
        variant="contained"
        onClick={handleExport}
        disabled={disabled}
        startIcon={<FaFileExcel />}
        sx={{
          borderRadius: "8px",
          backgroundColor: "#1976d2",
          textTransform: "none",
          height: "40px",
          paddingX: 2
        }}
      >
        Export Selected
      </Button>
     </div>

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        fullScreen={fullScreen}
        PaperProps={{
          sx: {
            borderRadius: 3,
            padding: 2,
            boxShadow: 8
          }
        }}
      >
        <DialogTitle>
          <Typography variant="h6" component="div" sx={{ fontWeight: "bold" }}>
            🎉 Export Complete
          </Typography>
        </DialogTitle>

        <DialogContent>
          <DialogContentText>
            You have successfully exported <strong>{exportCount}</strong> row
            {exportCount > 1 ? "s" : ""}. Would you like to clear the current selection?
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Box display="flex" justifyContent="space-between" width="100%" px={2}>
            <Button
              onClick={() => setOpenDialog(false)}
              variant="outlined"
              color="inherit"
              sx={{ borderRadius: 2 }}
            >
              Keep Selection
            </Button>

            <Button
              onClick={handleClearSelection}
              variant="contained"
              color="success"
              sx={{ borderRadius: 2 }}
            >
              Clear Selection
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ExportButton;
